import { BaseAjaxForm } from "mixs/base/form_ajax_mixin";
import { validations }  from "apps/actions/validations";
import { save }         from "apps/actions/common";
import serializeJSON    from 'utilities/serialize_json';
import Timelag          from 'utilities/timelag'
import { Global }       from 'mixs/orders/planner/model';
import { TAG_UPDATED, AJAX_ACCECCED, AJAX_ACCECCING } from 'apps/events';

class FormSave extends BaseAjaxForm {
  validFunction = validations.tasks_memo;
  submitFunction = save;
  // protected submit(){
  //   let e = new CustomEvent(AJAX_ACCECCING, {detail: this.tagScope});
  //   document.dispatchEvent(e);
  //   App.store.dispatch(this.submitFunction(this.saveParams()))
  //   e = new CustomEvent(AJAX_ACCECCING, {detail: this.tagScope});
  //   document.dispatchEvent(e);
  //   App.store.dispatch(this.submitFunction(this.saveParams()))
  //   e = new CustomEvent(AJAX_ACCECCING, {detail: this.tagScope});
  //   document.dispatchEvent(e);
  //   App.store.dispatch(this.submitFunction(this.saveParams()))
  // }
}
riot.mixin('forms.tasks.memos.save', FormSave as riot.TagMixin)
